import { useEffect, useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { SidebarContainer } from "../styled";
import { tokens } from "../../theme";
import { getLocalStorageValue } from "../../utils/localStorage";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ProfilePicPreviewModal from "../models/ProfilePicPreviewModal";
import DashboardSidebarPages from "./DashboardSidebarPages";
import "react-pro-sidebar/dist/css/styles.css";

const DashboardSidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [admin, setAdmin] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const adminRole = admin.accessLevel;

  useEffect(() => {
    const result = getLocalStorageValue("admin");
    setAdmin(result);
  }, []);

  return (
    <SidebarContainer>
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]}>
                  Dashboard
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  onClick={() => setOpenModal(true)}
                  src={`http://localhost:5000/${admin.profilePicture}`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {admin.firstName} {admin.lastName}
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  {admin.email}
                </Typography>
              </Box>
            </Box>
          )}

          <DashboardSidebarPages
            isCollapsed={isCollapsed}
            selected={selected}
            setSelected={setSelected}
            userRole={adminRole}
          />
        </Menu>
      </ProSidebar>

      {!isCollapsed && (
        <ProfilePicPreviewModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          colors={colors}
          profilePic={admin.profilePicture}
        />
      )}
    </SidebarContainer>
  );
};

export default DashboardSidebar;
